import { ViewModel,View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import  { UnitManipulationView } from "./unitManipulation-view"

export class UnitManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت واحد';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.units = ObservableArray.create<unit>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new UnitManipulationView();
    }
    public getTypeId(): string {
        return "VM-E5FDF60E-154D-4664-9C56-40349E8A161E"
    }
    public set units(v: ObservableArray<unit>) { this._units = v; } public get units(): ObservableArray<unit> { return this._units;} private _units: ObservableArray<unit>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllUnits',{
                FilteringInformation:filteringInformation
            });
            this.units.update(...result.Units.map(q=>{
                let r = new unit(this);
                r.id = q.Id;
                r.name = q.Name;
                r.symbol = q.Symbol;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async requestUnitCreation(){
        let editor = new unitEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }

}
export class unit extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set symbol(v: string) { this._symbol = v; } public get symbol(): string { return this._symbol;} private _symbol: string;
    
}

interface IServerUpdater{
    execute(unit:unit):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'واحد با موفقیت ثبت شد.';
    }
    async execute(unit: unit): Promise<void> {
        await ServerConnection.callServer('/Complex/WarehouseServices/CreateUnit',{
            Name:unit.name,
            Symbol:unit.symbol
        });
    }
}
class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'واحد با موفقیت به روز رسانی شد.';

    }
    execute(unit: unit): Promise<void> {
        throw new Error("Method not implemented.");
    }
}

export class unitEditor extends unit implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:ViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام واحد مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.name)){
            result.push('نشانه واحد مشخص نشده است.')
        }
        return result;
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت واحد');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}

export class UnitSelectorViewModel extends SelectorBaseViewModel<unitForSelector>{
    protected async loadData(): Promise<unitForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllUnits',{});
        return result.Units.map(q=>{
            let result = new unitForSelector(this);
            result.id = q.Id;
            result.title = q.Name;
            return result;
        });
    }

}

class unitForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);   
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}
